export default {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    color: 'hsla(0, 0%, 0%, 0.7)',
    textDecoration: 'none !important',
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: 'hsla(0, 0%, 0%, 0.2)',
    '&+*': {
      marginLeft: '8px',
    },
  },
  label: {
    fontSize: '14px',
  },
}
